<template>
  <div>
    <div class="banner-box">
      <img :src="cfg.ossDomain + '/banner.png'" alt="" @click="advertJump(homeSwiper[0].customUrl)">
    </div>
  </div>
</template>

<script>

export default {
  name: 'Banner',
  data() {
    const _this = this;
    return {
      homeSwiper: [],
      swiperOptions: {
        autoplay: true,
        loop: true,
        effect: 'fade',
        on: {
          click(e) {
            const jumpUrl = e.target.dataset.jumpUrl;
            if (jumpUrl) {
              _this.advertJump(jumpUrl);
            }
          }
        }
      }
    }
  },
  mounted() {
  },
  methods: {
    advertJump(applink) {
      if (applink.indexOf('http') === -1) {
        this.$router.push({
          path: applink
        })
      } else {
        var windowOpen = window.open()
        windowOpen.location = applink;
      }
    }
  }
}
</script>

<style lang="less" scoped>
    .banner-box {
        width: 100%;
        overflow: hidden;
        img {
          width: 100%;
          display: block;
          vertical-align: middle;
        }
    }
    @media screen and (max-width: 768px) {
        .banner-box {
            min-height: 0;
            img {
                width: 100%;
                height: 65px;
                object-fit: cover;
            }
        }
    }
</style>
